'use client';

export {
  Ratio,
  RATIO_LANDSCAPE,
  type RatioT,
  type RatioValue,
} from './Ratio';
